import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FareFamilyBenchmarkComponent } from './fare-family-benchmark.component';
import { FareFamilyTableService } from './fare-family-table.service';
import { StatusTagModule } from 'libraries/component/status-tag/status-tag.module';
import { PriceModule } from 'libraries/component/price/price.module';
import { DeltaPriceModule } from 'libraries/hotel/components/delta-price/delta-price.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { CacheQuotedAvailabilityModule } from '../../../../service/cache-quoted-availability/cache-quoted-availability.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { FareFamilyModule } from 'libraries/component/fare-family/fare-family.module';

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        FontAwesomeModule,
        StatusTagModule,
        PriceModule,
        DeltaPriceModule,
        NotificationModule,
        LoaderModule,
        CacheQuotedAvailabilityModule,
        BtnModule,
        FareFamilyModule,
        MatDialogModule
    ],
    declarations: [
        FareFamilyBenchmarkComponent,
    ],
    exports: [
        FareFamilyBenchmarkComponent,
    ],
    providers: [
        FareFamilyTableService,
    ]
})
export class FareFamilyBenchmarkModule {}